// (function () {
//   function playAll(root) {
//     root.querySelectorAll('.video-marquee-tile video-element').forEach((ve) => {
//       try {
//         ve.play();
//       } catch (_) {}
//     });
//   }

//   /**
//    * Hover alone is often blocked for unmuted video.play().
//    * 1) Poster .click() matches the theme’s deferred-load + play path (same as a real click).
//    * 2) If HTML5 video is already in the DOM, try play(); on NotAllowedError, play muted then unmute.
//    */
//   function playOnHover(videoElement) {
//     if (videoElement.hasAttribute('playing')) return;

//     const poster = videoElement.querySelector('.media__poster');

//     if (!videoElement.hasAttribute('loaded') && poster) {
//       poster.click();
//       return;
//     }

//     const v = videoElement.querySelector('video');
//     if (v) {
//       const p = v.play();
//       if (p && typeof p.catch === 'function') {
//         p.catch(() => {
//           const wasMuted = v.muted;
//           v.muted = true;
//           v.play().then(() => {
//             v.muted = wasMuted;
//           }).catch(() => {});
//         });
//       }
//       return;
//     }

//     try {
//       videoElement.play();
//     } catch (_) {}
//   }

//   function initMarquee(root) {
//     if (root.dataset.marqueeInit === 'true') return;
//     root.dataset.marqueeInit = 'true';

//     const loopAll = root.dataset.playAllLoop === 'true';

//     if (loopAll && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
//       requestAnimationFrame(() => {
//         playAll(root);
//       });
//     }

//     if (loopAll) {
//       return;
//     }

//     root.querySelectorAll('.video-marquee-tile').forEach((tile) => {
//       const ve = tile.querySelector('video-element');
//       if (!ve) return;
// (function () {
//   const HLS_CDN = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.7/dist/hls.min.js';

//   let hlsLibraryPromise = null;

//   function loadHlsLibrary() {
//     if (window.Hls) {
//       return Promise.resolve(window.Hls);
//     }
//     if (!hlsLibraryPromise) {
//       hlsLibraryPromise = new Promise((resolve, reject) => {
//         const s = document.createElement('script');
//         s.src = HLS_CDN;
//         s.async = true;
//         s.dataset.videoMarqueeHlsLib = '';
//         s.onload = () => resolve(window.Hls);
//         s.onerror = () => {
//           hlsLibraryPromise = null;
//           reject(new Error('HLS library failed to load'));
//         };
//         document.head.appendChild(s);
//       });
//     }
//     return hlsLibraryPromise;
//   }

//   function playMuted(video) {
//     video.muted = true;
//     const p = video.play();
//     if (p && typeof p.catch === 'function') {
//       p.catch(() => {});
//     }
//   }

//   function attachHls(video) {
//     const src = video.dataset.hlsSrc;
//     if (!src) return;

//     const tryNative = () => {
//       video.src = src;
//       video.addEventListener('loadedmetadata', () => playMuted(video), { once: true });
//     };

//     if (video.canPlayType('application/vnd.apple.mpegurl')) {
//       tryNative();
//       return;
//     }

//     loadHlsLibrary()
//       .then((Hls) => {
//         if (Hls.isSupported()) {
//           const hls = new Hls({
//             enableWorker: true,
//             lowLatencyMode: true,
//           });
//           hls.loadSource(src);
//           hls.attachMedia(video);
//           hls.on(Hls.Events.MANIFEST_PARSED, () => playMuted(video));
//           hls.on(Hls.Events.ERROR, (_, data) => {
//             if (data.fatal) {
//               hls.destroy();
//             }
//           });
//           return;
//         }
//         if (video.canPlayType('application/vnd.apple.mpegurl')) {
//           tryNative();
//         }
//       })
//       .catch(() => {
//         if (video.canPlayType('application/vnd.apple.mpegurl')) {
//           tryNative();
//         }
//       });
//   }

//   function playThemeVideos(root) {
//     root.querySelectorAll('video-element').forEach((ve) => {
//       try {
//         ve.play();
//       } catch (_) {}
//     });
//   }

//   function initMarquee(root) {
//     if (root.dataset.marqueeInit === 'true') return;
//     root.dataset.marqueeInit = 'true';

//     root.querySelectorAll('.js-video-marquee-hls').forEach((video) => {
//       attachHls(video);
//     });

//     if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
//       requestAnimationFrame(() => {
//         playThemeVideos(root);
//       });
//     }
//   }

//   function init() {
//     document.querySelectorAll('[data-video-marquee]').forEach(initMarquee);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   document.addEventListener('shopify:section:load', (event) => {
//     const id = event.detail?.sectionId;
//     const root =
//       (id && document.querySelector(`#shopify-section-${id} [data-video-marquee]`)) ||
//       event.target?.querySelector?.('[data-video-marquee]');
//     if (root) {
//       delete root.dataset.marqueeInit;
//       initMarquee(root);
//     }
//   });
// })();

//       tile.addEventListener('mouseenter', () => {
//         playOnHover(ve);
//       });

//       tile.addEventListener('mouseleave', () => {
//         try {
//           ve.pause();
//         } catch (_) {}
//       });
//     });
//   }

//   function init() {
//     document.querySelectorAll('[data-video-marquee]').forEach(initMarquee);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   document.addEventListener('shopify:section:load', (event) => {
//     const id = event.detail?.sectionId;
//     const root =
//       (id && document.querySelector(`#shopify-section-${id} [data-video-marquee]`)) ||
//       event.target?.querySelector?.('[data-video-marquee]');
//     if (root) initMarquee(root);
//   });
// })();


(function () {
  const HLS_CDN = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.7/dist/hls.min.js';
  let hlsLibraryPromise = null;
  const marqueeVideoWired = new WeakSet();

  function loadHlsLibrary() {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (!hlsLibraryPromise) {
      hlsLibraryPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = HLS_CDN;
        script.async = true;
        script.dataset.videoMarqueeHlsLib = '';
        script.onload = () => resolve(window.Hls);
        script.onerror = () => {
          hlsLibraryPromise = null;
          reject(new Error('HLS library failed to load'));
        };
        document.head.appendChild(script);
      });
    }
    return hlsLibraryPromise;
  }

  function ensureSafariAutoplayAttrs(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  }

  function playMuted(video) {
    if (!video || video.tagName !== 'VIDEO') return;
    ensureSafariAutoplayAttrs(video);
    const p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(() => {});
    }
  }

  /**
   * Safari often rejects the first play() inside CSS-animated tracks; retry when
   * the element has enough buffered data (loadeddata / canplay).
   */
  function wireMarqueeVideoAutoplay(video) {
    if (!video || video.tagName !== 'VIDEO') return;

    playMuted(video);

    if (video.readyState >= 2) {
      return;
    }

    if (marqueeVideoWired.has(video)) {
      return;
    }
    marqueeVideoWired.add(video);

    const onReady = () => playMuted(video);
    video.addEventListener('loadeddata', onReady, { once: true });
    video.addEventListener('canplay', onReady, { once: true });
    video.addEventListener('canplaythrough', onReady, { once: true });
  }

  function attachHls(video) {
    const src = video.dataset.hlsSrc;
    if (!src) return;

    ensureSafariAutoplayAttrs(video);

    const tryNative = () => {
      video.src = src;
      video.addEventListener('loadedmetadata', () => wireMarqueeVideoAutoplay(video), { once: true });
    };

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      tryNative();
      return;
    }

    loadHlsLibrary()
      .then((Hls) => {
        if (Hls && Hls.isSupported()) {
          const hls = new Hls({
            enableWorker: true,
            lowLatencyMode: true,
          });
          hls.loadSource(src);
          hls.attachMedia(video);
          hls.on(Hls.Events.MANIFEST_PARSED, () => wireMarqueeVideoAutoplay(video));
          hls.on(Hls.Events.ERROR, (_, data) => {
            if (data.fatal) hls.destroy();
          });
          return;
        }
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
          tryNative();
        }
      })
      .catch(() => {
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
          tryNative();
        }
      });
  }

  function playThemeVideoElements(root) {
    root.querySelectorAll('video-element').forEach((ve) => {
      const nativeVideo = ve.querySelector('video');
      if (nativeVideo) {
        wireMarqueeVideoAutoplay(nativeVideo);
      }
      try {
        ve.play();
      } catch (_) {}
    });
  }

  function playNativeVideos(root) {
    root.querySelectorAll('.video-marquee-tile video').forEach((video) => {
      wireMarqueeVideoAutoplay(video);
    });
  }

  function playAllMarqueeVideos() {
    document.querySelectorAll('[data-video-marquee]').forEach((root) => {
      playThemeVideoElements(root);
      playNativeVideos(root);
    });
  }

  /**
   * Safari (desktop + iOS) often refuses autoplay for <video> inside CSS-animated
   * parents (transform on the marquee track). IntersectionObserver + a later
   * play() retry when the tile is visible fixes many cases; first pointer
   * interaction fixes the rest (touchstart does not run on desktop Safari).
   */
  function observeMarqueeVideosForPlay(root) {
    if (typeof IntersectionObserver === 'undefined') return;

    const videos = root.querySelectorAll('.video-marquee-tile video, .video-marquee-tile .js-video-marquee-hls');
    if (!videos.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const v = entry.target;
          if (v.tagName === 'VIDEO') {
            wireMarqueeVideoAutoplay(v);
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.01 }
    );

    videos.forEach((v) => io.observe(v));
  }

  function initMarquee(root) {
    if (root.dataset.marqueeInit === 'true') return;
    root.dataset.marqueeInit = 'true';

    root.querySelectorAll('.js-video-marquee-hls').forEach((video) => {
      attachHls(video);
    });

    // Always start playback helpers: reduced motion only affects CSS scroll in the section, not video.
    requestAnimationFrame(() => {
      playThemeVideoElements(root);
      playNativeVideos(root);
      observeMarqueeVideosForPlay(root);
    });

    // Extra Safari passes: transform-heavy parents often need a later play().
    [100, 400, 1200].forEach((ms) => {
      window.setTimeout(() => {
        playThemeVideoElements(root);
        playNativeVideos(root);
      }, ms);
    });
  }

  function init() {
    document.querySelectorAll('[data-video-marquee]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const id = event.detail?.sectionId;
    const root =
      (id && document.querySelector(`#shopify-section-${id} [data-video-marquee]`)) ||
      event.target?.querySelector?.('[data-video-marquee]');
    if (root) {
      delete root.dataset.marqueeInit;
      initMarquee(root);
    }
  });

  document.addEventListener('page:loaded', init);

  // Desktop Safari never fires touchstart; pointerdown covers mouse + touch + pen.
  window.addEventListener(
    'pointerdown',
    () => {
      playAllMarqueeVideos();
    },
    { once: true, passive: true, capture: true }
  );

  window.addEventListener(
    'load',
    () => {
      playAllMarqueeVideos();
    },
    { once: true }
  );
})();
